<template>
  <div>
    <header-title
      :title="pageTitle"
      titlePrevious="الرئيسية"
      isNgo
      color="#048042"
    />
    <div class="container my-1">
      <data-table :fields="fields" :ep="endpoint" :id="$route.name">
      </data-table>
    </div>
  </div>
</template>
<script>
import HeaderTitle from "../../components/HeaderTitle.vue";
import DataTable from "@/components/data-table";
export default {
  components: {
    HeaderTitle,
    DataTable,
  },
  data() {
    return {
      fields: [{ key: "name", label: "الاسم الثلاثي" }],
    };
  },
  computed: {
    endpoint() {
      return this.$route.name == "ngo-admins"
        ? `v2/guest/directors/${this.$route.params.id}?type=administrative`
        : this.$route.name == "ngo-trustees"
        ? `v2/guest/directors/${this.$route.params.id}?type=trustee`
        : this.$route.name == "ngo-excutives"
        ? `v2/guest/directors/${this.$route.params.id}?type=executive`
        : `v2/guest/directors/${this.$route.params.id}?type=founder`;
    },
    pageTitle() {
      return this.$route.name === "ngo-admins"
        ? "أعضاء مجلس الإدارة"
        : this.$route.name === "ngo-trustees"
        ? "مجلس الأمناء"
        : this.$route.name === "ngo-excutives"
        ? "الإدارة التنفيذية"
        : "المؤسسين";
    },
  },
};
</script>
